module.exports = __webpack_public_path__ + "media/assets/icons/medical_icon-48dd6c27ffdc22488b5d97aacbf4d719.svg";